/**
 * TK-39 §1 — khối CHUNG cuối mỗi tab của trang Cài đặt chiến lược: "Áp cho: ◉ tủ đang chọn ○ mọi tủ của tuyến" + Gửi.
 * Cổng là cờ `canEditSchedule` của TUYẾN (ba ca — nhận quyết định, không nhận boolean).
 */
import { Upload } from 'lucide-react';
import { Button } from '../ui';
import { KhoaTheoTuyen } from '../Khoa';
import type { QuyetDinhCoTuyen } from '../../lib/quyen';
import { cauApLich, type KetApLich, type KetQuaApTu } from '../../lib/caiDat';

export type ApCho = 'tu' | 'tuyen';

export function KhoiApCho({ che, doiChe, onGui, dangGui, qd, soTuTuyen, tenTu, khoaGui = false }: {
  che: ApCho; doiChe: (c: ApCho) => void; onGui: () => void; dangGui: boolean;
  /** TK-45 §3: bảng còn ô sai (vd Nhóm ngoài 0–254) ⇒ Gửi khoá */
  khoaGui?: boolean;
  qd: QuyetDinhCoTuyen | 'khong-co-tuyen' | 'chua-biet'; soTuTuyen: number | null; tenTu: string;
}) {
  return (
    <div data-o="khoi-ap-cho" className="flex flex-wrap items-center gap-x-5 gap-y-2 rounded-xl border border-vien bg-nen px-4 py-3">
      <span className="text-sm font-semibold text-chu-1">Áp cho:</span>
      <label className="inline-flex min-h-[36px] items-center gap-2 text-sm text-chu-1">
        <input type="radio" name="ap-cho" className="h-4 w-4 accent-nhan" checked={che === 'tu'} onChange={() => doiChe('tu')} />
        <span className="min-w-0 truncate">tủ đang chọn ({tenTu})</span>
      </label>
      <label className="inline-flex min-h-[36px] items-center gap-2 text-sm text-chu-1">
        <input type="radio" name="ap-cho" className="h-4 w-4 accent-nhan" checked={che === 'tuyen'} onChange={() => doiChe('tuyen')} />
        <span>mọi tủ của tuyến{soTuTuyen !== null ? ` (${soTuTuyen})` : ''}</span>
      </label>
      <KhoaTheoTuyen qd={qd} co="canEditSchedule" className="ml-auto">
        <Button variant="primary" icon={<Upload className="h-4 w-4" />} loading={dangGui} disabled={qd !== 'cho-qua' || khoaGui} onClick={onGui} data-o="nut-gui">
          Gửi
        </Button>
      </KhoaTheoTuyen>
    </div>
  );
}

/* kết quả áp lịch cả tuyến: đã áp = lá · mất kết nối = xám (chưa biết, sẽ áp khi lên mạng) · từ chối = hổ phách (cần người xem) */
const NHAN_KET: Record<KetQuaApTu, { nhan: string; lop: string }> = {
  'da-ap': { nhan: 'Đã áp', lop: 'text-tot' },
  'mat-ket-noi': { nhan: 'Mất kết nối — sẽ áp khi lên mạng', lop: 'text-chua-ro' },
  'tu-choi': { nhan: 'Từ chối', lop: 'text-canh' },
  'cho-hoi-dap': { nhan: 'Chưa hồi đáp', lop: 'text-chu-2' },
};
export function KetApLichTuyen({ k }: { k: KetApLich }) {
  return (
    <div data-o="ket-ap-tuyen" className="rounded-xl border border-vien bg-nen px-4 py-3 text-sm">
      <p className="m-0 font-semibold text-chu-1" data-o="cau-ap-tuyen">{cauApLich(k)}</p>
      <ul className="m-0 mt-1.5 list-none space-y-0.5 p-0">
        {k.tu.map((t) => (
          <li key={t.cabinetId} className="flex flex-wrap gap-x-2" data-ket={t.ketQua}>
            <span className="text-chu-1">{t.name}</span>
            <span className={NHAN_KET[t.ketQua].lop}>{NHAN_KET[t.ketQua].nhan}{t.lyDo ? ` (${t.lyDo})` : ''}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
